module.exports = "/_next/static/images/b6d11dff20b9539d45aa304701a37800-mateo_1@3x.png.webp";